var map = {
	"./bike_dark.svg": "8eea",
	"./bike_light.svg": "75af",
	"./coco_dark.svg": "86c2",
	"./coco_light.svg": "46b9",
	"./ebike_dark.svg": "1f83",
	"./ebike_light.svg": "864d",
	"./modeds_dark.svg": "68e8",
	"./modeds_light.svg": "bcd4",
	"./scooter_dark.svg": "2df7",
	"./scooter_light.svg": "7871"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b14b";